import { render, staticRenderFns } from "./ProjectChangeDetail.vue?vue&type=template&id=0264cd28&"
import script from "./ProjectChangeDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectChangeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports